import { getLanguage } from '../services/GNRL';
import { translate, translateAPICode } from '../services/TranslationService';
import { getBrowserName, getDeviceType } from './platformCheck';
const { getAuthToken, logout = () => {} } = window;

function createMetadataHeader() {
    let data;

    data = getBrowserName();

    data += ',' + getDeviceType();
    return data;
}

function checkResponseStatus(response) {
    if (response.status >= 500) {
        var err = Error('Server response not ok.');
        err.details = {
            response: response.status,
            user_description: translate('OTHER.errorOcurred'),
        };
        throw err;
    }
}

class WEBAPI {
    static constructURL(url, serviceName, baseURL) {
        var newURL = '';
        if (!baseURL) {
            if (serviceName === 'SSO') {
                newURL = this.baseUrlSSO + url;
            } else if (serviceName === 'CHAT') {
                newURL = this.baseUrlChat + url;
            } else {
                newURL = this.baseUrlAPP + url;
            }

            return newURL;
        } else {
            return baseURL;
        }
    }

    static createHeaders() {
        let headersObj = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
            Expires: 0,
            ClientNOVOData: createMetadataHeader(),
        };
        const token = getAuthToken();
        if (token) headersObj['Authorization'] = `Bearer ${token}`;
        return headersObj;
    }

    static createHeadersURLFormEncoded() {
        let headersObj = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ClientNOVOData: createMetadataHeader(),
        };
        const token = getAuthToken();
        if (token) headersObj['Authorization'] = `Bearer ${token}`;
        return headersObj;
    }

    static createHeadersMultipart() {
        let headersObj = {
            Accept: 'application/json',
            ClientNOVOData: createMetadataHeader(),
            // "Content-Type": "multipart/form-data",
        };
        const token = getAuthToken();
        if (token) headersObj['Authorization'] = `Bearer ${token}`;
        return headersObj;
    }

    static getURL(url, serviceName, baseURL, mockData) {
        if (mockData) {
            return new Promise((res, rej) => {
                setTimeout(() => {
                    res(mockData);
                }, 0);
            });
        }

        var constructedURL = WEBAPI.constructURL(url, serviceName, baseURL);

        var headers = null;
        headers = this.createHeaders();

        var that = this;
        if (that.enableLogging) {
            console.log('getting url ' + constructedURL);
        }

        var fetchChain = fetch(constructedURL, {
            method: 'GET',
            headers: headers,
        })
            .then((response) => {
                checkResponseStatus(response);
                return response.json();
            })
            .then(function (jsonData) {
                if (that.enableLogging) {
                    console.log('get url ' + constructedURL + ' response');
                    console.log(jsonData);
                }

                if (jsonData['error'] === true) {
                    let err = null;
                    if (jsonData['code'] === '109') {
                        return WEBAPI.refreshToken().then((res) => {
                            return WEBAPI.getURL(url, serviceName, baseURL);
                        });
                    } else if (jsonData['code'] === '108') {
                        if (logout) logout();
                        err = createWEBAPIError(serviceName, jsonData);
                        throw err;
                    } else {
                        err = createWEBAPIError(serviceName, jsonData);
                        throw err;
                    }
                } else {
                    return jsonData;
                }
            })
            .catch((err) => {
                if (!err?.details?.user_description) {
                    err.details = {
                        ...err.details,
                        user_description: translate('OTHER.errorOcurred'),
                    };
                }

                console.log(err);
                throw err;
            });

        return fetchChain;
    }

    static postURL(url, data, serviceName, baseURL, mockData) {
        if (mockData) {
            return new Promise((res, rej) => {
                res(mockData);
            });
        }

        var constructedURL = WEBAPI.constructURL(url, serviceName, baseURL);
        var headers = this.createHeadersURLFormEncoded();
        var that = this;
        if (that.enableLogging) {
            console.log('post url ' + constructedURL);
            console.log('with data');
            console.log(data);
            // console.log(JSON.stringify(data));
        }

        return fetch(constructedURL, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data), //TODO is this required?
            // body: data //TODO is this required?
        })
            .then((response) => {
                checkResponseStatus(response);
                return response.json();
            })
            .then(function (jsonData) {
                if (that.enableLogging) {
                    console.log('post url ' + constructedURL + ' response');
                    console.log(jsonData);
                }

                if (jsonData['error'] === true) {
                    let err = null;
                    if (jsonData['code'] === '109') {
                        return WEBAPI.refreshToken().then((res) => {
                            return WEBAPI.postURL(
                                url,
                                data,
                                serviceName,
                                baseURL,
                            );
                        });
                    } else if (jsonData['code'] === '108') {
                        if (logout) logout();
                        err = createWEBAPIError(serviceName, jsonData);
                        throw err;
                    } else {
                        err = createWEBAPIError(serviceName, jsonData);
                        throw err;
                    }
                }

                return jsonData;
            })
            .catch((err) => {
                if (!err?.details?.user_description) {
                    err.details = {
                        ...err.details,
                        user_description: translate('OTHER.errorOcurred'),
                    };
                }
                console.log('ERROR IN POSTING');
                console.log(err);

                throw err;
            });
    }

    static getTranslations(language) {
        var currentlang = language ? language : getLanguage();
        currentlang = currentlang === 'gr' ? 'el' : currentlang;
        return this.getURL(
            'system/translations' + '/' + currentlang,
            'SSO',
            null,
        )
            .then((translationDataSSO) => {
                return translationDataSSO;
            })
            .then((translationDataSSO) => {
                return this.getURL(
                    'system/translations' + '/' + currentlang,
                    'NOVOVILLE',
                ).then((translationDataNOVOVILLE) => {
                    var responses = {
                        ...translationDataSSO.result.responses,
                        ...translationDataNOVOVILLE.result.responses,
                    };
                    var allTranslationsData = {
                        ...translationDataSSO.result,
                        ...translationDataNOVOVILLE.result,
                        responses,
                    };
                    return allTranslationsData;
                });
            });
    }

    static postAnswer = (
        name,
        said,
        token,
        language,
        target,
        medium,
        client_key,
        preview_expiration_date,
    ) => {
        var data = {
            name,
            said,
            medium,
            user_token: token,
            language,
            client_key,
            preview_expiration_date,
        };

        return WEBAPI.postURL(
            `discussions/${target}/${medium}`,
            data,
            'NOVOVILLE',
            null,
            null,
        );
    };
}

function serviceAndCodeToTranslatable(serviceName, apiCode) {
    if (serviceName === 'SSO') {
        return 'ssoapi_' + apiCode;
    } else {
        return 'api_' + apiCode;
    }
}

function createWEBAPIError(serviceName, jsonData) {
    let code = serviceAndCodeToTranslatable(serviceName, jsonData['code']);
    let err = new WebApiError('API Error', code);
    let user_description = translateAPICode(
        serviceAndCodeToTranslatable(serviceName, jsonData['code']),
    );
    let dynamicTranslationArgs = jsonData['args'];

    if (dynamicTranslationArgs) {
        Object.keys(dynamicTranslationArgs).forEach((key) => {
            var regex = new RegExp(key, 'g');
            user_description = user_description.replace(
                regex,
                dynamicTranslationArgs[key],
            );
        });
    }

    err.details = {
        error_code: jsonData['code'],
        error_result: jsonData['result'],
        user_description,
    };
    return err;
}

WEBAPI.baseUrlAPP = process.env.REACT_APP_BASE_URL_APP;
WEBAPI.baseUrlSSO = process.env.REACT_APP_BASE_URL_SSO;
WEBAPI.baseUrlChat = process.env.REACT_APP_BASE_URL_CHAT;
WEBAPI.enableLogging = true;
WEBAPI.redirectPaymentPage = WEBAPI.constructURL('cards/redirect_page', 'SSO');

export default WEBAPI;

class WebApiError extends Error {
    constructor(message, code) {
        super(message);
        this.type = 'WEBAPI Error';
        this.code = code;
    }
}
